export function AccommodationMatrix({ value, onChange }) {
  const floors = ['lowerGround', 'ground', 'first', 'second', 'third', 'other']
  const floorLabels = {
    lowerGround: 'Lower Ground',
    ground: 'Ground',
    first: 'First',
    second: 'Second',
    third: 'Third',
    other: 'Other'
  }
  const roomTypes = ['living', 'bedrooms', 'bathrooms', 'other']
  const roomLabels = {
    living: 'Living Rooms',
    bedrooms: 'Bedrooms',
    bathrooms: 'Bathrooms',
    other: 'Other Rooms'
  }

  const matrix = value || {}

  const handleChange = (floor, roomType, val) => {
    const newMatrix = {
      ...matrix,
      [floor]: {
        ...(matrix[floor] || {}),
        [roomType]: val === '' ? 0 : parseInt(val, 10)
      }
    }
    onChange(newMatrix)
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border border-slate-300">
        <thead>
          <tr className="bg-slate-100">
            <th className="border border-slate-300 px-4 py-2 text-left font-semibold text-slate-700">
              Floor
            </th>
            {roomTypes.map(type => (
              <th key={type} className="border border-slate-300 px-4 py-2 text-center font-semibold text-slate-700">
                {roomLabels[type]}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {floors.map(floor => (
            <tr key={floor} className="hover:bg-slate-50">
              <td className="border border-slate-300 px-4 py-2 font-medium text-slate-700">
                {floorLabels[floor]}
              </td>
              {roomTypes.map(type => (
                <td key={type} className="border border-slate-300 px-2 py-2">
                  <input
                    type="number"
                    min="0"
                    max="99"
                    value={matrix[floor]?.[type] || ''}
                    onChange={(e) => handleChange(floor, type, e.target.value)}
                    className="w-full px-2 py-1 text-center border border-slate-200 rounded focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default AccommodationMatrix
